<template>
  <div class="d-flex justify-content-between align-items-center w-100">
    <b-form-checkbox
      :value="addAnother"
      @change="onCheckboxChange"
    >
      Add Another
    </b-form-checkbox>
    <div>
      <b-button
        variant="secondary"
        :disabled="loading"
        class="mr-2"
        @click="cancel"
      >
        Cancel
      </b-button>
      <b-button
        variant="primary"
        :disabled="loading || disabled"
        @click="ok"
      >
        OK
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalFooter',
  props: {
    addAnother: false,
    loading: {
      type: Boolean,
      default: false,
    },
    cancel: {
      type: Function,
    },
    ok: {
      type: Function,
    },
    disabled: Boolean,
  },
  methods: {
    onCheckboxChange(val) {
      this.$emit('input', val);
    },
  },
};
</script>

<style scoped>

</style>